import { type ThemePalette } from './ThemePalette.types';

/**
 * Common colours shared between brands
 */
const commonColors = [
  { name: 'white', value: ' #ffffff' },
  { name: 'mist', value: ' #f8f8f8' },
  { name: 'hairline', value: ' #e1e1e1' },
  { name: 'off-white', value: ' #e5e5e5' },
  { name: 'mid-grey', value: ' #c4c4c4' },
  { name: 'deep-grey', value: ' #737579' },
  { name: 'grey', value: ' #6c6c6c' },
  { name: 'neutral-grey', value: ' #7a738c' },
  { name: 'dark-grey', value: ' #58595b' },
  { name: 'charcoal', value: ' #353535' },
  { name: 'black', value: ' #000000' },
  { name: 'error', value: '#FE0C00' },
] satisfies ThemePalette;

export default commonColors;
